import { weekHoursSummary, type BusinessHours } from "@fusiqo/vozqi-shared";

/** «Horario de atención»: each run of days with its hours, «Cerrado» on the rest. Nothing when it gave none. */
export function ProfileHours({ hours }: { hours: BusinessHours }) {
  const lines = weekHoursSummary(hours);
  if (lines.length === 0) return null;
  return (
    <section className="profile-card" aria-labelledby="profile-hours">
      <h2 id="profile-hours" className="profile-card-title">
        Horario de atención
      </h2>
      <dl className="profile-hours">
        {lines.map((line) => (
          <div key={line.days} className="profile-hours-row">
            <dt>{line.days}</dt>
            <dd className={line.closed ? "profile-hours-closed" : "tabular"}>{line.hours}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
